// video-carousel-bioemblem.js

function playVideo(video) {
  // plays video
  video.play();
}

function pauseVideo(video) {
  // pauses video
  video.pause();
}

function muteVideo(video) {
  // mutes video
  video.muted = true;
}

function unmuteVideo(video) {
  // unmutes video
  video.muted = false;
}

function togglePlayingClass(video, isPlaying) {
  // adds/removes ".playing" class to video block container when its video is playing/paused
  const container = video.closest(".video-block-container");
  if (isPlaying) {
    container.classList.add("playing");
  } else {
    container.classList.remove("playing");
  }
}

function pauseAllVideosExcept(currentVideo) {
  // pauses all videos except the one that is currently playing
  const allVideos = document.querySelectorAll(".video-block-container video");
  allVideos.forEach((video) => {
    if (video !== currentVideo) {
      pauseVideo(video);
    }
  });

  const modalVideos = document.querySelectorAll(".video-gallery-section video");
  modalVideos.forEach((video) => {
    if (video !== currentVideo) {
      pauseVideo(video);
    }
  });
}

let isMuted = false;

function updateMuteButton() {
  // updates mute button state
  const muteButton = document.querySelector(
    ".video-gallery-modal .mute-button"
  );
  const mutedIcon = muteButton.querySelector(".muted-icon");
  const unmutedIcon = muteButton.querySelector(".unmuted-icon");

  if (isMuted) {
    mutedIcon.style.display = "block";
    unmutedIcon.style.display = "none";
  } else {
    mutedIcon.style.display = "none";
    unmutedIcon.style.display = "block";
  }
}

function toggleMuteState() {
  // toggles mute state
  isMuted = !isMuted;
  updateMuteButton();

  const centerSection = document.querySelector(".video-gallery-section.center");
  const video = centerSection.querySelector("video");

  if (video) {
    if (isMuted) {
      muteVideo(video);
    } else {
      unmuteVideo(video);
    }
  }
}

function updateArrowVisibility(centerIndex, totalBlocks) {
  // updates arrow visibility based on center index
  const leftArrow = document.querySelector(
    ".video-gallery-modal .gallery-arrow.left-arrow"
  );
  const rightArrow = document.querySelector(
    ".video-gallery-modal .gallery-arrow.right-arrow"
  );

  if (centerIndex === 0) {
    leftArrow.style.display = "none";
  } else {
    leftArrow.style.display = "flex";
  }

  if (centerIndex === totalBlocks - 1) {
    rightArrow.style.display = "none";
  } else {
    rightArrow.style.display = "flex";
  }
}

function openModal() {
  // opens video gallery modal
  const modal = document.getElementById("video-gallery-modal");
  if (modal) {
    modal.style.display = "flex";
    document.body.classList.add("no-scroll"); // Disable scroll on main page
  }
}

function closeModal() {
  // closes video gallery modal
  const modal = document.getElementById("video-gallery-modal");
  if (modal) {
    modal.style.display = "none";
    document.body.classList.remove("no-scroll"); // Enable scroll on main page

    // pause all videos in the modal
    const modalVideos = modal.querySelectorAll("video");
    modalVideos.forEach((video) => {
      pauseVideo(video);
      muteVideo(video);
      // mute videos when modal closes
    });

    // clear the contents
    const sections = ["far-left", "left", "center", "right", "far-right"];
    sections.forEach((section) => {
      const sectionElement = document.querySelector(
        `.video-gallery-section.${section}`
      );
      if (sectionElement) {
        sectionElement.innerHTML = "";
      }
    });
  }
}

function populateModal(centerIndex) {
  // populates modal with video blocks
  const videoBlockContainers = document.querySelectorAll(
    ".video-block-container"
  );
  const totalBlocks = videoBlockContainers.length;
  const sections = ["far-left", "left", "center", "right", "far-right"];

  // clear all sections before populating
  sections.forEach((section) => {
    const sectionElement = document.querySelector(
      `.video-gallery-section.${section}`
    );
    sectionElement.innerHTML = "";
  });

  sections.forEach((section, i) => {
    const sectionElement = document.querySelector(
      `.video-gallery-section.${section}`
    );
    const sectionIndex = centerIndex - 2 + i;

    if (sectionIndex >= 0 && sectionIndex < totalBlocks) {
      const blockClone = videoBlockContainers[sectionIndex].cloneNode(true);

      const videoLink = blockClone.querySelector(".video-link");
      if (videoLink) {
        videoLink.style.display = "flex";
        videoLink.setAttribute("aria-hidden", "false");
        videoLink.removeAttribute("tabindex");
      }

      sectionElement.appendChild(blockClone);

      if (section === "center") {
        const video = blockClone.querySelector("video");
        if (video) {
          // Create and append play icon overlay
          const playIconOverlay = document.createElement("div");
          playIconOverlay.classList.add("play-icon-overlay");
          playIconOverlay.innerHTML = "&#9654;";
          blockClone.appendChild(playIconOverlay);

          if (isMuted) {
            muteVideo(video);
          } else {
            unmuteVideo(video);
          }
          playVideo(video);
          pauseAllVideosExcept(video);

          // pause/play video on click
          video.addEventListener("click", function () {
            if (video.paused) {
              playVideo(video);
              playIconOverlay.style.opacity = "0";
              setTimeout(() => {
                playIconOverlay.style.display = "none";
              }, 500);
            } else {
              pauseVideo(video);
              playIconOverlay.style.display = "block";
              setTimeout(() => {
                playIconOverlay.style.opacity = "1";
              }, 10);
            }
          });

          // show/hide play icon
          video.addEventListener("play", function () {
            playIconOverlay.style.opacity = "0";
            setTimeout(() => {
              playIconOverlay.style.display = "none";
            }, 500);
          });

          video.addEventListener("pause", function () {
            playIconOverlay.style.display = "block";
            setTimeout(() => {
              playIconOverlay.style.opacity = "1";
            }, 10);
          });
        }
      }
    }
  });

  updateArrowVisibility(centerIndex, totalBlocks);
  openModal();
}

let currentIndex = 0;

function updateModalIndex(increment) {
  const videoBlockContainers = document.querySelectorAll(
    ".video-block-container"
  );
  const totalBlocks = videoBlockContainers.length;
  currentIndex = (currentIndex + increment + totalBlocks) % totalBlocks;

  // clear content before repopulating
  const sections = ["far-left", "left", "center", "right", "far-right"];
  sections.forEach((section) => {
    const sectionElement = document.querySelector(
      `.video-gallery-section.${section}`
    );
    sectionElement.innerHTML = "";
  });

  populateModal(currentIndex);
}

// debounce function (to prevent multiple rapid calls)
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

document.addEventListener("DOMContentLoaded", function () {
  const videoBlockContainers = document.querySelectorAll(
    ".video-block-container"
  );
  const closeModalButton = document.querySelector(
    ".video-gallery-modal .close-button"
  );
  const muteButton = document.querySelector(
    ".video-gallery-modal .mute-button"
  );
  const leftArrowMain = document.querySelector(
    ".video-carousel-container .left-arrow"
  );
  const rightArrowMain = document.querySelector(
    ".video-carousel-container .right-arrow"
  );
  const videoCarousel = document.querySelector(".video-carousel");

  function updateMainArrowsVisibility() {
    // Check if there is content to scroll to on the left
    if (videoCarousel.scrollLeft > 0) {
      leftArrowMain.style.opacity = "1";
      leftArrowMain.style.pointerEvents = "auto";
    } else {
      leftArrowMain.style.opacity = "0";
      leftArrowMain.style.pointerEvents = "none";
    }

    // check if there is content to scroll to on the right
    if (
      videoCarousel.scrollLeft <
      videoCarousel.scrollWidth - videoCarousel.clientWidth
    ) {
      rightArrowMain.style.opacity = "1";
      rightArrowMain.style.pointerEvents = "auto";
    } else {
      rightArrowMain.style.opacity = "0";
      rightArrowMain.style.pointerEvents = "none";
    }
  }

  const debouncedUpdateMainArrowsVisibility = debounce(
    updateMainArrowsVisibility,
    200
  );

  function scrollCarousel(direction) {
    const videoBlocks = Array.from(videoBlockContainers);
    const currentScrollPosition = videoCarousel.scrollLeft;
    const carouselWidth = videoCarousel.clientWidth;

    let scrollToPosition = currentScrollPosition;

    if (direction === "right") {
      for (let i = 0; i < videoBlocks.length; i++) {
        const block = videoBlocks[i];
        const blockLeft = block.offsetLeft;
        const blockRight = blockLeft + block.clientWidth;

        if (blockRight > currentScrollPosition + carouselWidth) {
          scrollToPosition = blockLeft;
          break;
        }
      }
    } else if (direction === "left") {
      for (let i = videoBlocks.length - 1; i >= 0; i--) {
        const block = videoBlocks[i];
        const blockLeft = block.offsetLeft;
        const blockRight = blockLeft + block.clientWidth;

        if (blockLeft < currentScrollPosition) {
          scrollToPosition = blockRight - carouselWidth;
          break;
        }
      }
    }

    videoCarousel.scrollTo({
      left: scrollToPosition,
      behavior: "smooth",
    });
  }

  // event listeners for main carousel arrows
  if (leftArrowMain) {
    leftArrowMain.addEventListener("click", function () {
      scrollCarousel("left");
    });
  }

  if (rightArrowMain) {
    rightArrowMain.addEventListener("click", function () {
      scrollCarousel("right");
    });
  }

  // update arrows visibility on initial load and on scroll
  updateMainArrowsVisibility();
  videoCarousel.addEventListener("scroll", debouncedUpdateMainArrowsVisibility);

  videoBlockContainers.forEach((block, index) => {
    block.dataset.index = index;
    const video = block.querySelector("video");

    if (video) {
      video.muted = true;
      // always mute carousel videos

      let hoverTimeout;

      block.addEventListener("mouseover", function () {
        if (window.matchMedia("(min-width: 990px)").matches) {
          // for desktop widths
          hoverTimeout = setTimeout(() => {
            pauseAllVideosExcept(video);
            playVideo(video);
          }, 250);
        }
      });

      block.addEventListener("mouseout", function () {
        clearTimeout(hoverTimeout);
      });

      block.addEventListener("click", function () {
        currentIndex = index;
        populateModal(currentIndex);
      });

      video.addEventListener("play", function () {
        togglePlayingClass(video, true);
        pauseAllVideosExcept(video); // Ensure other videos are paused
      });

      video.addEventListener("pause", function () {
        togglePlayingClass(video, false);
      });

      video.addEventListener("ended", function () {
        togglePlayingClass(video, false);
      });
    }

    // Prevent playing video when .video-link is clicked
    const videoLink = block.querySelector(".video-link");
    if (videoLink) {
      videoLink.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }
  });

  // close modal on close button click
  if (closeModalButton) {
    closeModalButton.addEventListener("click", closeModal);
  }

  // close modal on escape key press
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  // add event listeners to modal arrows
  const leftArrow = document.querySelector(
    ".video-gallery-modal .gallery-arrow.left-arrow"
  );
  const rightArrow = document.querySelector(
    ".video-gallery-modal .gallery-arrow.right-arrow"
  );

  if (leftArrow) {
    leftArrow.addEventListener("click", function () {
      updateModalIndex(-1);
    });
  }

  if (rightArrow) {
    rightArrow.addEventListener("click", function () {
      updateModalIndex(1);
    });
  }

  // add event listener to mute button
  if (muteButton) {
    muteButton.addEventListener("click", toggleMuteState);
  }

  // set initial mute button state
  updateMuteButton();

  // intersection observer to autoplay videos on mobile devices
  if (window.matchMedia("(max-width: 989px)").matches) {
    // Mobile only
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector("video");
          if (entry.isIntersecting) {
            if (video) {
              playVideo(video);
            }
          } else {
            if (video) {
              pauseVideo(video);
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    videoBlockContainers.forEach((container) => {
      observer.observe(container);
    });
  }
});
